var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "641ee956f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54.570312 147 L 195 147 L 195 314.894531 L 54.570312 314.894531 Z M 54.570312 147 ",
    clipRule: "nonzero",
    "data-index": 0,
    style: {
      visibility: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6fabbc94fa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180 147 L 320 147 L 320 314.894531 L 180 314.894531 Z M 180 147 ",
    clipRule: "nonzero",
    "data-index": 1,
    style: {
      visibility: "visible"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "none",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "none",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 187.042969 270.242188 C 182.984375 270.242188 179.710938 266.972656 179.710938 262.914062 L 179.710938 197.359375 C 179.710938 193.304688 182.984375 190.03125 187.042969 190.03125 C 191.101562 190.03125 194.371094 193.304688 194.371094 197.359375 L 194.371094 262.914062 C 194.371094 266.972656 191.101562 270.242188 187.042969 270.242188 Z M 187.042969 270.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero",
    "data-index": 2,
    style: {
      visibility: "visible",
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 228.699219 270.242188 C 228.078125 270.242188 227.457031 270.160156 226.835938 269.996094 C 222.945312 268.957031 220.585938 264.941406 221.621094 261.050781 L 239.054688 195.496094 C 240.089844 191.605469 244.105469 189.246094 247.996094 190.28125 C 251.890625 191.316406 254.25 195.332031 253.214844 199.226562 L 235.78125 264.777344 C 234.910156 268.046875 231.929688 270.242188 228.699219 270.242188 Z M 228.699219 270.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero",
    "data-index": 3,
    style: {
      visibility: "visible",
      fill: "rgb(0, 0, 0)",
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 145.382812 270.242188 C 142.152344 270.242188 139.171875 268.089844 138.300781 264.777344 L 120.867188 199.226562 C 119.832031 195.332031 122.152344 191.316406 126.085938 190.28125 C 129.980469 189.203125 133.996094 191.5625 135.03125 195.496094 L 152.464844 261.050781 C 153.5 264.941406 151.179688 268.957031 147.246094 269.996094 C 146.625 270.160156 146.003906 270.242188 145.382812 270.242188 Z M 145.382812 270.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero",
    "data-index": 4,
    style: {
      visibility: "visible"
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#641ee956f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 187.457031 314.21875 L 144.515625 314.21875 C 122.195312 314.21875 101.984375 300.140625 94.285156 279.1875 L 55.316406 156.945312 C 54.613281 154.710938 55.027344 152.265625 56.394531 150.402344 C 57.761719 148.496094 59.953125 147.378906 62.316406 147.378906 L 187.457031 147.378906 C 191.515625 147.378906 194.785156 150.652344 194.785156 154.710938 C 194.785156 158.765625 191.515625 162.039062 187.457031 162.039062 L 72.335938 162.039062 L 108.15625 274.425781 C 113.621094 289.332031 128.28125 299.5625 144.515625 299.5625 L 187.457031 299.5625 C 191.515625 299.5625 194.785156 302.832031 194.785156 306.890625 C 194.785156 310.949219 191.515625 314.21875 187.457031 314.21875 Z M 187.457031 314.21875 ",
    fillOpacity: 1,
    fillRule: "nonzero",
    "data-index": 5,
    style: {
      visibility: "visible",
      opacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6fabbc94fa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 230.398438 314.21875 L 187.457031 314.21875 C 183.398438 314.21875 180.125 310.949219 180.125 306.890625 C 180.125 302.832031 183.398438 299.5625 187.457031 299.5625 L 230.398438 299.5625 C 246.632812 299.5625 261.289062 289.332031 266.878906 274.09375 L 302.574219 161.996094 L 187.457031 161.996094 C 183.398438 161.996094 180.125 158.726562 180.125 154.667969 C 180.125 150.609375 183.398438 147.339844 187.457031 147.339844 L 312.597656 147.339844 C 314.914062 147.339844 317.152344 148.457031 318.519531 150.359375 C 319.886719 152.222656 320.300781 154.667969 319.59375 156.902344 L 280.753906 278.855469 C 272.925781 300.140625 252.757812 314.21875 230.441406 314.21875 Z M 230.398438 314.21875 ",
    fillOpacity: 1,
    fillRule: "nonzero",
    "data-index": 6,
    style: {
      visibility: "visible",
      fill: "rgb(0, 0, 0)",
      opacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 98.921875 159.761719 C 97.554688 159.761719 96.1875 159.386719 94.988281 158.601562 C 91.59375 156.40625 90.597656 151.894531 92.75 148.496094 L 139.628906 75.160156 C 141.824219 71.765625 146.335938 70.769531 149.730469 72.925781 C 153.128906 75.121094 154.121094 79.632812 151.96875 83.027344 L 105.09375 156.367188 C 103.683594 158.558594 101.324219 159.761719 98.921875 159.761719 Z M 98.921875 159.761719 ",
    fillOpacity: 1,
    fillRule: "nonzero",
    "data-index": 7,
    style: {
      visibility: "visible",
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 275.992188 159.761719 C 273.589844 159.761719 271.226562 158.558594 269.820312 156.367188 L 222.945312 83.027344 C 220.75 79.632812 221.742188 75.078125 225.179688 72.925781 C 228.578125 70.730469 233.132812 71.722656 235.285156 75.160156 L 282.160156 148.496094 C 284.355469 151.894531 283.363281 156.449219 279.925781 158.601562 C 278.722656 159.386719 277.355469 159.761719 275.992188 159.761719 Z M 275.992188 159.761719 ",
    fillOpacity: 1,
    fillRule: "nonzero",
    "data-index": 8,
    style: {
      visibility: "visible"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.cdc6fc2e0cae3b7fd5ae4331b38594a3.svg";
export { ForwardRef as ReactComponent };